import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './rootReducer';
import { sentryListenerMiddleware } from './middleware/sentryMiddleware';
import { thirdPartyScriptsListener } from './middleware/thirdPartyScripts';

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .prepend(sentryListenerMiddleware.middleware)
      .prepend(thirdPartyScriptsListener.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
